import centroMap from '../../../../assets/centro.webp';
import generalMap from '../../../../assets/mapaGeneral.webp';
import tollocanMap from '../../../../assets/tollocan.webp';
import ceuMap from '../../../../assets/CEU.webp';
import parqueMap from '../../../../assets/parque.webp';
import norteMap from '../../../../assets/norte.webp';
import nubesMapas from '../../../../assets/nubesmapas.webp';
import puntos1 from '../../../../assets/puntos1.webp';
import puntos2 from '../../../../assets/puntos2.webp';
import NohoCredit from './NohoCredit';
import { replayButton, secondary } from './ExperienceLayout';
import './ReviewScreen.css';

const catedralModel = '/models/catedralCentro.glb';

export default function MapHubScreen({
  mapFrameRef, inSubmap, backToGeneralMap, gpsZone, postGpsZone,
  gps, onLocate, onNavigate, onLogout, handleSoloPlay, activeTournament, reviewEnabled,
}) {
  const soloLabel = inSubmap
    ? 'Jugar aquí'
    : gpsZone
      ? 'Maldecir esta zona'
      : 'Jugar solo';
  const canRequestGps = gps?.status !== 'inside' && gps?.status !== 'locating';
  const mapGpsStatus = gps?.status === 'outside'
    ? `Fuera de las 5 zonas${gps.nearestLabel ? ` · cerca de ${gps.nearestLabel}` : ''}`
    : gps?.status === 'error'
      ? (gps.message || 'No pudimos obtener tu ubicación')
      : 'Ubicación no activada';
  const mapGpsWarning = gps?.status === 'outside'
    ? 'Fuera de una zona válida no podrás obtener todas las medallas.'
    : 'Sin GPS no podrás obtener todas las medallas.';
  const mapUrl = '/toluca_mapa_de_supervivencia.html?' + new URLSearchParams({
    v: '55',
    catedral: catedralModel,
    centro: centroMap,
    general: generalMap,
    norte: norteMap,
    tollocan: tollocanMap,
    ceu: ceuMap,
    parque: parqueMap,
    puntos1,
    puntos2,
    nubes: nubesMapas,
  });
    return <div className="fixed inset-0 z-50 overflow-hidden bg-[#0A1A0F] text-left">
    <iframe
      ref={mapFrameRef}
      title="Mapa de supervivencia de Toluca"
      src={mapUrl}
      onLoad={postGpsZone}
      className="absolute inset-0 h-full w-full border-0"
    />
    <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(180deg,rgba(10,26,15,.82)_0%,transparent_28%,transparent_68%,rgba(10,26,15,.82)_100%)]" aria-hidden="true" />

    <nav className="pointer-events-auto absolute left-1/2 top-[7rem] z-10 flex w-max max-w-[96vw] -translate-x-1/2 flex-wrap justify-center gap-1.5 sm:top-16" aria-label="Opciones del mapa">
        {inSubmap && (
          <button onClick={backToGeneralMap} aria-label="Volver al mapa general" className={[
            'flex min-h-[44px] items-center gap-2 rounded-[8px] border border-[#2f2f42] bg-[#14141d]/95',
            'px-4 py-3 text-[11px] font-black uppercase tracking-[.14em] text-[#d7d7de]',
            'shadow-[0_2px_10px_rgba(0,0,0,.55)] sm:text-[12px]',
          ].join(' ')}>← Mapa general</button>
        )}
        <button onClick={() => onNavigate('ranking')} className={[
          'flex min-h-[44px] items-center border border-[#7C3AED] bg-[#7C3AED] px-3 py-2 text-[8px]',
          'font-black uppercase tracking-[.1em] text-white shadow-[3px_3px_0_rgba(0,0,0,.45)]',
          'sm:text-[9px]',
        ].join(' ')}>Ranking</button>
        <button onClick={() => onNavigate('pending')} className={[
          'flex min-h-[44px] items-center border border-[#7EC54A] bg-[#0F1F12]/90 px-3 py-2',
          'text-[8px] font-black uppercase tracking-[.1em] text-[#F7E04B]',
          'shadow-[3px_3px_0_rgba(0,0,0,.38)] sm:text-[9px]',
        ].join(' ')}>Duelos</button>
        {reviewEnabled && (
          <button
            onClick={() => onNavigate('review')}
            aria-label="Ver tu review del festival"
            className={[
              'rv-cta flex min-h-[44px] items-center gap-1 border border-white px-3 py-2 text-[9px]',
              'font-black uppercase tracking-[.1em] text-black sm:text-[10px]',
            ].join(' ')}
          >
            <span aria-hidden="true">✨</span> Review
          </button>
        )}
        {activeTournament && activeTournament.showButton !== false && (
          <button onClick={() => onNavigate('tournament')} className={[
            'flex min-h-[44px] items-center border border-[#F7E04B] bg-[#F7E04B] px-3 py-2 text-[8px]',
            'font-black uppercase tracking-[.1em] text-black shadow-[3px_3px_0_rgba(0,0,0,.45)]',
            'sm:text-[9px]',
          ].join(' ')}>🏆 Torneo</button>
        )}
    </nav>

    <div className="pointer-events-none absolute inset-x-0 bottom-0 z-10 p-3 pb-[max(.75rem,env(safe-area-inset-bottom))] sm:p-5 sm:pb-[max(1.25rem,env(safe-area-inset-bottom))]">
      {!inSubmap && gps?.status === 'inside' && (
        <p className={[
          'mx-auto mb-2 w-max max-w-[92vw] truncate rounded-full border border-[#7EC54A]',
          'bg-[#0A1A0F]/95 px-4 py-2 text-[11px] font-black uppercase tracking-[.14em] text-[#F7E04B]',
          'shadow-[0_2px_10px_rgba(0,0,0,.55)]',
        ].join(' ')} aria-live="polite">📍 Estás aquí: {gps.label}</p>
      )}
      {gps?.status === 'locating' && (
        <p className={[
          'mx-auto mb-2 w-max max-w-[92vw] rounded-full border border-[#7EC54A]/50 bg-[#0A1A0F]/95',
          'px-4 py-2 text-[11px] font-black uppercase tracking-[.14em] text-[#C5E6A0]',
        ].join(' ')} role="status">📍 Localizando tu posición…</p>
      )}
      {canRequestGps && (
        <div className={[
          'pointer-events-auto mx-auto mb-2 flex w-max max-w-[94vw] items-center gap-2 rounded-full',
          'border border-[#7EC54A]/55 bg-[#0A1A0F]/95 p-1 pl-3 shadow-[0_2px_10px_rgba(0,0,0,.55)]',
        ].join(' ')}>
          <span className="min-w-0 text-[9px] font-bold leading-3 text-[#C5E6A0]" role="status">
            <span className="block truncate uppercase tracking-[.08em]">📍 {mapGpsStatus}</span>
            <span className="block truncate text-[#F7E04B]">{mapGpsWarning}</span>
          </span>
          <button
            type="button"
            onClick={() => onLocate?.()}
            className={[
              'flex min-h-[44px] shrink-0 items-center rounded-full border border-[#7EC54A] bg-[#1A4D2E]',
              'px-3 py-2 text-[9px] font-black uppercase tracking-[.1em] text-white active:bg-[#2E7D32]',
            ].join(' ')}
            aria-label="Intentar activar el permiso de ubicación"
          >
            {gps?.status === 'outside' ? 'Reintentar GPS' : 'Activar GPS'}
          </button>
        </div>
      )}
      <div className="pointer-events-auto mx-auto grid max-w-xl grid-cols-2 gap-2 sm:gap-3">
        <button onClick={handleSoloPlay} className={replayButton}>{soloLabel}</button>
        <button onClick={() => onNavigate('vs-setup')} className={secondary}>Lanzar un duelo</button>
      </div>
      <footer className="pointer-events-none mx-auto mt-2 grid max-w-xl grid-cols-[1fr_auto_1fr] items-end gap-2">
        <div className="flex flex-wrap items-center justify-start gap-x-1">
          <button
            type="button"
            onClick={() => onNavigate('credits')}
            aria-label="Ver créditos"
            title="Ver créditos"
            className="pointer-events-auto min-h-[44px] px-3 py-2 text-[10px] font-bold uppercase tracking-wider text-white/70 hover:text-white focus-visible:text-white"
          >
            Créditos
          </button>
        </div>
        <NohoCredit variant="footer" />
        <div className="flex justify-end">
          {onLogout && (
            <button
              type="button"
              onClick={onLogout}
              aria-label="Cerrar sesión"
              title="Cerrar sesión"
              className="pointer-events-auto min-h-[44px] px-3 py-2 text-[10px] font-bold uppercase tracking-wider text-white/70 underline underline-offset-4 hover:text-white focus-visible:text-white"
            >
              Cerrar sesión
            </button>
          )}
        </div>
      </footer>
    </div>
  </div>;
}
